import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function SpomenikIcon(props: SvgIconProps) {
  return <SvgIcon {...props} >
    <svg version="1.1" id="SpomenikIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="#FFFFFF" d="M66.1,69.7L50,12L30.4,82.3h42.8V69.8L66.1,69.7L66.1,69.7z" />
      <line fill="none" x1="63.7" y1="76" x2="63.7" y2="76" />
      <path fill="#3CAA78" d="M63.2,73.6L50,26.2L35.5,78.5h34v-5L63.2,73.6L63.2,73.6z M42,73.6l8-28.8l8,28.8H42z" />
    </svg>
  </SvgIcon>
}

export default SpomenikIcon;
